
<div class="row">
    <div class="col">
        <div class="list-group" style="margin-top:0.5rem; background-color: #CE1126;">
            <h2 style="padding-left: 0.5em; margin-top: 0.25em; color: #ffffff;">{{ title }}</h2>
            <div *ngFor="let item of items" class="list-group-item">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                    <a (click)="unCompleteQuestItem(item.id)"><fa-icon *ngIf="item.complete" class="text-success" [icon]="faCheckCircle"></fa-icon></a>
                    {{ item.title }}</h5>
                <small>{{ item.points }} PTS</small>
            </div>
            <p class="mb-1">{{ item.description }}</p>
            <div *ngIf="!item.complete" >
                <!--<form *ngIf="item.type == 'basic'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)" class="float-right">-->
                <form *ngIf="item.type == 'basic'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)">
                    <input type="hidden" name="id" [ngModel]="item.id">
                    <button style="margin-top: 0.5em" type="submit" class="btn btn-success">Complete</button>
                </form>

                <!--<form *ngIf="item.type == 'text'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)" class="d-flex w-100 justify-content-between">-->
                <form *ngIf="item.type == 'text'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)">
                    <input type="hidden" name="id" [ngModel]="item.id">
                    <span>Answer: <input name="answer" type="text" required minlength='1' [ngModel]="item.answer"></span><br />
                    <button style="margin-top: 1em;" type="submit" [disabled]="!qiForm.form.valid" [className]="!qiForm.form.valid ? 'btn btn-outline-secondary' : 'btn btn-success'">Complete</button>
                </form>

                <!--<form *ngIf="item.type == 'photo'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)" class="d-flex w-100 justify-content-between">-->
                <form *ngIf="item.type == 'photo'" #qiForm="ngForm" (ngSubmit)="completeQuestItem(qiForm.value)">
                    <input type="hidden" name="id" [ngModel]="item.id">
                    <input type="file" name="image" id="image" accept="image/" required (change)="changeFileInput(item.id, $event.target.files)"><br />
                    <button style="margin-top: 1em;" type="submit" [disabled]="this.fileInputSet(item.id)" [className]="(this.fileInputSet(item.id)) ? 'btn btn-outline-secondary' : 'btn btn-success'">Complete</button>
                </form>
            </div>
            </div>
        </div>
    </div> 
</div>